var map = {
	"./calendar": [
		"./src/app/calendar/calendar.module.ts",
		"default~calendar~company~reservation~station~tank~user",
		"default~calendar~station",
		"calendar"
	],
	"./company": [
		"./src/app/company/company.module.ts",
		"default~calendar~company~reservation~station~tank~user",
		"company"
	],
	"./reservation": [
		"./src/app/reservation/reservation.module.ts",
		"default~calendar~company~reservation~station~tank~user",
		"reservation"
	],
	"./station": [
		"./src/app/station/station.module.ts",
		"default~calendar~company~reservation~station~tank~user",
		"default~calendar~station",
		"station"
	],
	"./tank": [
		"./src/app/tank/tank.module.ts",
		"default~calendar~company~reservation~station~tank~user",
		"tank"
	],
	"./user": [
		"./src/app/user/user.module.ts",
		"default~calendar~company~reservation~station~tank~user",
		"user"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;